import React from "react";
import { LucideIcon } from "lucide-react";

interface TabButtonProps {
	id: string;
	icon: LucideIcon;
	label: string;
	active: boolean;
	onClick: (id: string) => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
	id,
	icon: Icon,
	label,
	active,
	onClick,
}) => (
	<button
		onClick={() => onClick(id)}
		className={`flex items-center gap-3 px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 ${
			active
				? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg"
				: "bg-white text-gray-600 hover:bg-gray-50 hover:text-indigo-600 shadow-md border border-gray-200"
		}`}
	>
		<Icon size={20} />
		<span className="hidden sm:inline">{label}</span>
	</button>
);
